import React, { useState } from 'react';
import styles from './index.module.css';
import OrderTable from './components/OrderTable';

const Orders = () => {
  const [activeSection, setActiveSection] = useState('all');

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.sectionTabs}>
          <button
            className={`${styles.tabButton} ${activeSection === 'all' ? styles.tabButtonActive : ''}`}
            onClick={() => setActiveSection('all')}
          >
            Open Orders
          </button>
        </div>

        {activeSection === 'all' && (
          <div className={styles.sectionContent}>
            <OrderTable />
          </div>
        )}
      </div>
    </div>
  );
};

export default Orders;